import script from "./cardMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./cardMenu.vue?vue&type=script&lang=ts&setup=true"

import "./cardMenu.vue?vue&type=style&index=0&id=711205de&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711205de"]])

export default __exports__